import { IonicSelectableComponent, IonicSelectableItemTemplateDirective } from 'ionic-selectable';
import { Component, input, model } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

import { ComposeMessageInterface } from '@app/interfaces/message.interface';
import { ContactInterface, PhoneKind } from '@app/interfaces/contact.interface';

function getMobileContacts(contacts: ContactInterface[]) {
  return contacts.reduce((acc, contact) => {
    const mobilePhones = contact.PHONES.filter(
      (phone) => phone.KIND === PhoneKind.mobile || phone.KIND === PhoneKind.CELL,
    );

    const mobileContacts = mobilePhones.map((phone) => ({
      uniqueId: `${contact.SHA}_${phone.PHONE}`,
      SHA: contact.SHA,
      FULLNAME: contact.FULLNAME,
      FIRSTNAME: contact.FIRSTNAME,
      FAMILYNAME: contact.FAMILYNAME,
      GENDER: contact.GENDER,
      LANGUAGE: contact.LANGUAGE,
      VIP_FAMILY: contact.VIP_FAMILY,
      VIP_BUSINESS: contact.VIP_BUSINESS,
      PHONE: phone.PHONE,
    }));

    return [...acc, ...mobileContacts];
  }, [] as ComposeMessageInterface[]);
}

@Component({
  selector: 'app-select-contact',
  templateUrl: './select-contact.component.html',
  styleUrls: ['./select-contact.component.scss'],
  imports: [IonicSelectableItemTemplateDirective, IonicSelectableComponent, IonicModule, FormsModule],
})
export class SelectContactComponent {
  contacts = input<ComposeMessageInterface[], ContactInterface[]>([], {
    transform: (arr) => getMobileContacts(arr),
  });
  sender = model<ComposeMessageInterface>();

  contactHeader(record?: ComposeMessageInterface, recordIndex?: number, records?: ComposeMessageInterface[]) {
    const firstChar = record?.FAMILYNAME?.[0].toUpperCase() ?? '';
    const lastFirstChild =
      recordIndex && recordIndex > 0 ? (records?.[recordIndex - 1].FAMILYNAME?.[0].toUpperCase() ?? '') : '';
    if (firstChar && /[A-Z]/.test(firstChar) && (recordIndex === 0 || firstChar !== lastFirstChild)) {
      return firstChar;
    }
    return null;
  }
}
